import { useCallback, useEffect, useState } from "react";
import Fuse from "fuse.js";
import moment from "moment";
import { FaPlus } from "react-icons/fa";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import Card from "../atoms/Card";
import CardHeader from "../atoms/CardHeader";
import IconButton from "../atoms/IconButton";
import Modal from "../molecules/Modal";
import GastosTable from "../organisms/gastos/GastosTable";
import GastosCreate from "../organisms/gastos/GastosCreate";
import GastosFilter from "../organisms/gastos/GastosFilter";
import { GET_GASTOS } from "../../api/apiGastos";
import { GET_INMUEBLES } from "../../api/apiInmuebles";
import useModal from "../../hooks/useModal";
import { getInmobiliaria } from "../../utils/getInmobiliaria";
import { exportGastosToExcel } from "../../utils/excel/ExportGastosToExcel";
import Breadcrumb from "../molecules/Breadcrumb";

const GastosTemplate = () => {
    const [gastos, setGastos] = useState();
    const [filteredGastos, setFilteredGastos] = useState();
    const [inmuebles, setInmuebles] = useState();
    const [loading, setLoading] = useState(false);
    const { open, isOpen, close } = useModal();
    const [filters, setFilters] = useState({
        name: "", inmuebles: [], dateRange: { start: "", end: "" },
    });

    const getGastos = useCallback ( async () => {
        try {
            setLoading(true);
            try {
                const gastosData = await GET_GASTOS();
                setFilteredGastos(gastosData);
                setGastos(gastosData);
            } catch (errorGastos) {
                console.error(errorGastos);
            }
            try {
                const inmueblesData = await GET_INMUEBLES();
                setInmuebles(inmueblesData)
            } catch (errorInmuebles) {
                console.error(errorInmuebles);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false)
        }
    }, []);

    useEffect(() => {
        getGastos();
    }, [getGastos]);

    const options = inmuebles?.map(im => ({
        value: im.id,
        label: `${im?.name} - ${getInmobiliaria(im.real_estate)}`,
    }));

    useEffect(() => {
        if (!gastos) return;

        const fuse = new Fuse(gastos, {
            keys: ["name"],
            threshold: 0.3,
        });

        let result = [...gastos];

        const searchTerms = `${filters.name}`.trim();
        if (searchTerms) {
            result = fuse.search(searchTerms).map(r => r.item);
        }

        if (filters.dateRange.start && filters.dateRange.end) {
            result = result.filter(g => {
                const date = moment(g.date);
                return (
                    date.isSameOrAfter(moment(filters.dateRange.start), "day") &&
                    date.isSameOrBefore(moment(filters.dateRange.end), "day")
                );
            });
        }

        if (filters.inmuebles && filters.inmuebles.length > 0) {
            result = result.filter(gasto =>
                filters.inmuebles.includes(gasto.propertieId)
            );
        }

        setFilteredGastos(result);
    }, [filters, gastos]);

    return (
        <div className="flex flex-col gap-4">
            <CardHeader
                left={
                    <Breadcrumb
                        items={[
                            { label: "Inicio", to: "/inicio" },
                            { label: "Gastos", to: null },
                        ]}
                    />
                }
                right={
                    <div className="flex flex-row gap-2">
                        <IconButton
                            icon={PiMicrosoftExcelLogoFill}
                            bgColor="bg-green-600" iconColor="text-white"
                            onClick={() => exportGastosToExcel(filteredGastos, inmuebles)}
                        />
                        <IconButton icon={FaPlus} bgColor="bg-green-600" onClick={open}/>
                    </div>
                }
            />
            <Card>
                <GastosFilter filters={filters} setFilters={setFilters} options={options} />
                <GastosTable data={filteredGastos} loading={loading} refetch={getGastos} inmuebles={inmuebles}/>
            </Card>
            {isOpen &&
                <Modal title="Agregar gasto" onClose={close}>
                    <GastosCreate onClose={close} refetch={getGastos} />
                </Modal>
            }
        </div>
    );
};

export default GastosTemplate;